import {useEffect} from 'react'
import analytics from '../../common/analytics/index.js'
import {INVENTORY_APP_PANEL, showUpgradeModal} from '../Modals/UpgradeModal.js'
import ButtonPrimary from '../../common/components/Button/ButtonPrimary.js'
import {usesAppsSelector} from '../../data/company.js'
import {useSelector} from '../../store.js'
import {showFeatureLockedModal} from '../Modals/FeatureLockedModal.js'
import {INVENTORY_APP_PREMIUM} from '../../common/constants/Apps.js'

export default function StocktakeFeaturePage() {
  const usesApps = useSelector(usesAppsSelector)

  useEffect(() => {
    analytics.trackEvent('stocktake_feature_lock')
  }, [])

  return (
    <>
      <div className="row margin-top-30">
        <div className="medium-8 medium-centered columns align-center margin-top-30">
          <h3 className="fs-03 lh-md margin-top-5 margin-bottom-5">
            <strong>Bring Your Inventory to Life</strong>
          </h3>
          <p className="fs-02 lh-md">
            Gain visibility into your inventory processes and enable your team
            to make cost-effective decisions.
          </p>
        </div>
      </div>
      <div className="row margin-top-30 flex">
        <div className="medium-7 columns">
          <img
            className="screenshot"
            src="https://storage.googleapis.com/ordoro-pappy-assets/public/stocktake-feature-lock.png"
            alt="Stocktakes Demo"
          />
        </div>
        <div className="medium-5 columns flex--justify-col">
          <div className="margin-bottom-15">
            {usesApps ? (
              <p className="fs-01 lh-lg margin-bottom-25">
                To gain access to{' '}
                <a
                  className="btn btn--link darker border-underline v-align-base"
                  href="https://support.ordoro.com/how-can-i-create-a-bill-of-materials-bom/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Stocktake</span>
                </a>
                , you need to be on the{' '}
                <strong>Premium Plan of our Inventory App</strong>.
              </p>
            ) : (
              <p className="fs-01 lh-lg margin-bottom-25">
                Upgrade your account with our{' '}
                <strong>Inventory Management Module</strong> to gain access to{' '}
                <a
                  className="btn btn--link darker border-underline v-align-base"
                  href="https://support.ordoro.com/how-can-i-create-a-bill-of-materials-bom/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Stocktake</span>
                </a>{' '}
                and other inventory features.
              </p>
            )}

            <div>
              {usesApps ? (
                <ButtonPrimary
                  size="x-md"
                  className="meta--feature-lock-bom"
                  alt
                  onClick={() =>
                    showUpgradeModal({
                      panel: INVENTORY_APP_PANEL,
                      selectedInventoryApp: INVENTORY_APP_PREMIUM,
                    })
                  }
                >
                  Enable Inventory (Premium)
                </ButtonPrimary>
              ) : (
                <ButtonPrimary
                  size="x-md"
                  className="meta--feature-lock-bom"
                  alt
                  onClick={() => showFeatureLockedModal('inventory')}
                >
                  Get the Inventory Management Module
                </ButtonPrimary>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
